import {Gender} from "../enums/gender.enum";

export class EnumHelper {
    static isInNumericEnum(value: number, enumeration: any): boolean {
        return value in enumeration;
    }

    static isInStringEnum(value: string, enumeration: any): boolean {
        return Object.values(enumeration).includes(value);
    }
    
    static genderString(filterType: Gender) {
        switch (filterType) {
            case Gender.Undisclosed:
                return "Prefer not to say";
            case Gender.Other:
                return "Other";
            case Gender.Female:
                return "Female";
            case Gender.Male:
                return "Male";
            case Gender.NonBinary:
                return "Non-binary";
            case Gender.GenderFluid:
                return "Genderfluid";
            default:
                return "";
        }
    }
}